module.exports = __webpack_public_path__ + "static/sunda-outdoor-0580c6ce10bb0d1cd5f4f0b01cd6123f.png";